import { LoginBoxStyled, LoginStyled } from "../Auth/components/styled/LoginStyled";
import { PageKYCStyled } from "./styled/PageKYCStyled";

export default function PageKYC() {
    return <PageKYCStyled>
        <LoginStyled>
            <LoginBoxStyled>
                <h4>Welcome to the Meridiana Platform!</h4>
                <p>To ensure the security of your account and grant you full access to our platform, we require all
                    users to complete the Know Your Customer (KYC) verification process. This essential procedure helps
                    us maintain a safe and compliant trading environment.</p>

                <p><b>Why KYC Verification is necessary:</b></p>
                <p>KYC verification is an industry-standard procedure designed to verify the identity of our users. It
                    helps us prevent fraud, money laundering, and ensures your account safety. By completing
                    the KYC process, you can fully unlock the potential of our platform.</p>

                <p><b>Instructions to Complete KYC:</b></p>
                <p>We have sent detailed KYC verification instructions to the email address from which you registered
                    with us. Please check your inbox (including your spam folder) for an email titled “KYC Verification
                    Instructions from Meridiana Platform.”</p>

                <p>If you cannot find the email or have any questions regarding the KYC process, please reach out to our
                    support team at support@meridiana-trading.com. Our dedicated support agents are here to assist you
                    every step of the way.</p>

                <p>Once you have successfully completed the KYC process, your account will be fully verified, and you’ll
                    gain access to all features and benefits of the Meridiana Platform.</p>

                <p>Best regards,<br/>
                    The Meridiana Platform Team</p>
            </LoginBoxStyled>
        </LoginStyled>
    </PageKYCStyled>
}
